// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YaC8","colBig":"styles_colBig__2mfFE","colSmall":"styles_colSmall__1AV3w"};